import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import type { AreaPrice } from "./area-price.model";

@CwtModel({ name: 'area' })
@CwtCrudContract({ path: '/area', searchMapper: (s) => ({ name: { regexp: s } }) })
export class Area extends CwtApiEntity {
    @CwtProp() name: string;
    @CwtProp({ ref: 'area-price' }) areaPrice: AreaPrice;
}